import React from 'react'
import classNames from 'classnames'
import { VideoCardProps } from './VideoCard.d'
import Description from '@toasttab/shared/src/components/atoms/Description/Description'
import BrollVideo from '@toasttab/shared/src/components/atoms/Broll/BrollVideo'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import { resolvePrefix } from '@toasttab/shared/src/utils/assetUtils'

const VideoCard = ({
  badgeColor,
  logo,
  rxType,
  image,
  video,
  href,
  classes,
  heapInteraction,
  webm
}: VideoCardProps) => {
  const videoCardClasses = classNames(classes, {
    'flex bg-gray-30 rounded-lg overflow-hidden relative w-full h-full max-h-[420px] group':
      true
  })
  const cardBadgeColor = classNames(
    'py-1 px-2 inline-block mx-auto rounded-badge',
    {
      'bg-white': !badgeColor,
      'bg-yellow-25': badgeColor === 'yellow'
    }
  )
  return (
    <a
      href={href}
      data-interaction={heapInteraction ?? ''}
      className='rounded-lg overflow-hidden'
    >
      <div className={videoCardClasses}>
        {video ? (
          <div className='border-box rounded-lg overflow-hidden relative min-w-[264px] w-full min-h-[420px] h-full relative z-0'>
            <LazyLoadComponent threshold={500}>
              <BrollVideo videoName={resolvePrefix(video)} webm={webm} />
            </LazyLoadComponent>
          </div>
        ) : (
          ''
        )}
        {image && !video ? (
          <picture>
            <source srcSet={`${image}.webp`} type='image/webp' />
            <img
              loading='lazy'
              src={image}
              alt={`${video}-video`}
              className='h-full w-full object-cover object-center absolute top-0 bottom-0 right-0 left-0 lazyload'
            />
          </picture>
        ) : (
          ''
        )}
        <div className='gradient h-full w-full absolute top-0 bottom-0 right-0 left-0 bg-hp-video-card-gradient z-20 rounded-lg' />
        <div className='absolute top-0 bottom-0 right-0 left-0 flex flex-col justify-end z-30'>
          <div className='px-10 pb-6 z-30 text-center'>
            {logo ? (
              <img
                src={logo}
                alt={video}
                className='lazyload mb-4 mx-auto group-hover:-translate-y-2  transition-transform duration-100 ease-in'
                width='184'
                height='96'
              />
            ) : (
              ''
            )}
            <div className={cardBadgeColor}>
              <Description variation='badge'>{rxType}</Description>
            </div>
          </div>
        </div>
      </div>
    </a>
  )
}

export default VideoCard
